export default function mainNodeAttractForce(strength = 0.1) {
  let nodes;
  // distance under which the force is disabled
  const NEAR_DIST = 2;

  function force(alpha) {
    if (!nodes) return;
    const maxForce = Math.abs(strength) * 2;
    for (const n of nodes) {
      if (!n.virtual || !n.mainNode) continue;
      const m = n.mainNode;
      const dx = (n.x || 0) - (m.x || 0);
      const dy = (n.y || 0) - (m.y || 0);
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (!dist || dist < NEAR_DIST) continue;
      let f = strength * dist * alpha;
      if (f > maxForce) f = maxForce;
      else if (f < -maxForce) f = -maxForce;
      const fx = (dx / dist) * f;
      const fy = (dy / dist) * f;
      m.vx += fx;
      m.vy += fy;
    }
  }

  force.initialize = function (_) {
    nodes = _;
  };

  force.strength = function (_) {
    return arguments.length ? ((strength = +_), force) : strength;
  };

  return force;
}
